// Без zod: функция нужна клиенту API на каждой странице, а соседние утилиты
// zod-normalization.ts тянули zod (~280 КБ) в общий чанк (KAN-974).

/**
 * Утилита для нормализации ключей объекта из PascalCase в camelCase
 */
export function normalizeKeysToCamelCase<T extends Record<string, unknown>>(
  obj: T,
): Record<string, unknown> {
  if (!obj || typeof obj !== "object" || Array.isArray(obj)) {
    return obj;
  }

  const normalized: Record<string, unknown> = {};

  for (const [key, value] of Object.entries(obj)) {
    const camelKey = pascalToCamel(key);
    let normalizedValue = value;

    if (value && typeof value === "object") {
      if (Array.isArray(value)) {
        normalizedValue = value.map((item) =>
          typeof item === "object" && item !== null
            ? normalizeKeysToCamelCase(item as Record<string, unknown>)
            : item,
        );
      } else {
        normalizedValue = normalizeKeysToCamelCase(
          value as Record<string, unknown>,
        );
      }
    }

    normalized[camelKey] = normalizedValue;
  }

  return normalized;
}

/**
 * Преобразует PascalCase в camelCase
 */
function pascalToCamel(str: string): string {
  if (!str) return str;
  // Не трогаем "словари" и ключи-акронимы вида UNRANKED / ID / URL,
  // иначе ломаем маппинг (например, draft rank costs).
  if (!/[a-z]/.test(str)) return str;
  return str.charAt(0).toLowerCase() + str.slice(1);
}
